import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './product.css';

const Product = ({number, id, title, unit, ourPrice, generalPrice, score, minValue, info, setShoppingCart, shopSelectedItems}) => {
    
    const [mode, setMode] = useState('unselect');
    const [value, setValue] = useState(minValue);

    const incrementEventHandler = () =>  {
        setValue(prev => prev + 1);
        setShoppingCart(id, 'INCREMENT', minValue)
    }
    const decrementValueHandler = () => {
        if(value > minValue)
        setValue(prev => prev - 1);
        else {
            setMode('unselect');
        }
        setShoppingCart(id, 'DECREMENT', minValue)
    }
    useEffect(() => {
        shopSelectedItems.forEach(item => {
            if(item._id === id){
                setMode('select');
                setValue(item.count)
            }
        });
    },[shopSelectedItems, id])
    return ( 
        <div className="product-layer text-dark col-12 col-md-6 col-lg-4">
            <div className="align-self-center product-layer-title w-100">
                <span>{title}</span>
            </div>
            <div className="product-part">
                <small className="font-weight-bold">
                    <span >قیمت بازار (هر {unit})</span>
                    <span className="mx-1">:</span>
                    <span className="text-muted d-block">{generalPrice} تومان</span>
                </small>
                <small className="font-weight-bold">
                    <span >قیمت ما (هر {unit})</span>
                    <span className="mx-1">:</span>
                    <span className="text-success d-block">{ourPrice} تومان</span>
                </small>
                <small className="font-weight-bold">
                    <span >حداقل میزان خرید</span>
                    <span className="mx-1">:</span>
                    <span className="text-muted ">{minValue} {unit}</span>
                </small>
                <div className="" style={{height:'15px'}}>
                        <p className="ratings">
                            {/* <Link to='' onClick={ event => event.preventDefault()} className="mark small">امتیاز :</Link> */}
                            <Link to='' onClick={ event => event.preventDefault()}>
                                <span className={score >= 5 ? "fa fa-star" : "fa fa-star-o"}></span>
                            </Link>
                            <Link to='' onClick={ event => event.preventDefault()}>
                                <span className={score >= 4 ? "fa fa-star" : "fa fa-star-o"}></span>
                            </Link>
                            <Link to='' onClick={ event => event.preventDefault()}>
                                <span className={score >= 3 ? "fa fa-star" : "fa fa-star-o"}></span>
                            </Link>
                            <Link to='' onClick={ event => event.preventDefault()}>
                                <span className={score >= 2 ? "fa fa-star" : "fa fa-star-o"}></span>
                            </Link>
                            <Link to='' onClick={ event => event.preventDefault()}>
                                <span className={score >= 1 ? "fa fa-star" : "fa fa-star-o"}></span>
                            </Link>
                            <Link 
                                to='' 
                                onClick={ event => event.preventDefault()} 
                                className="mark bg-transparent"
                                style={{position:'relative', bottom:'3px'}}
                            >
                                {score}
                            </Link>
                        </p>
                </div>
            </div>
            <div className="product-part">
                <small className="font-weight-bold" style={{height:'70px', overflow:'auto'}}>
                    <span >توضیحات</span>
                    <span className="mx-1">:</span>
                    <span className="text-muted">{info}</span>
                </small>
                <div className='d-flex ml-auto mt-1'>
                    {
                        mode  === 'select' ?
                        <React.Fragment>
                            <button className='btn btn-sm btn-success d-flex justify-content-center align-items-center' 
                                style={{width:'27px', height:'27px'}}
                                onClick={incrementEventHandler}
                                >
                                <i className='fa fa-plus'></i>
                            </button>
                            <span className='mx-1 font-weight-bold'>
                                {value} 
                                <span style={{fontSize:'.8rem', marginRight:'4px'}}>{unit}</span>
                            </span>
                            <button className='btn btn-sm btn-danger d-flex justify-content-center align-items-center' 
                                style={{width:'27px', height:'27px'}}
                                onClick={decrementValueHandler}
                                >
                                <i className='fa fa-minus'></i>
                            </button>
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <button 
                                className='btn btn-sm btn-success d-flex justify-content-center align-items-center' 
                                style={{width:'130px', height:'27px'}}
                                onClick={() => {
                                    setMode('select');
                                    setShoppingCart(id, 'INCREMENT', minValue);
                                }}
                                >
                                    <i className='fa fa-shopping-cart mr-1'></i>
                                    افزودن به سبد 
                            </button>
                        </React.Fragment>
                    }
                </div>
            </div>
           
        </div>

     );
}
 
export default Product;